import { Fragment } from "react";
import usePage from "../hooks/usePage";
import Menu from "../modules/public/menu/menu";
import Footer from "../modules/public/footer/footer";
import { Col, Container, Row, Table } from "react-bootstrap";
import styles from "./ContentBox.module.css";

const ContentBox = () => {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}

        <Container className="content-style rtl-all">
          <Row className="m-1 p-1 mt-4">
            <Col lg={7} xs={12}>
              {pageText}
            </Col>

            <Col lg={5} xs={12} className="mt-3">
              <p>قیمت های زیر با احتساب کارمزد بسته بندی و چسب میباشد.</p>

              <Table striped bordered hover className={styles.table}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>نوع بسته بندی</th>
                    <th>ابعاد</th>
                    <th>قیمت</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>پاکت</td>
                    <td>A5 (22*11)</td>
                    <td className={styles.priceTD}>
                      <span>41,162</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>پاکت</td>
                    <td>A4 (31*22)</td>
                    <td className={styles.priceTD}>
                      <span>46,003</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>پاکت</td>
                    <td>A3 (30*45)</td>
                    <td className={styles.priceTD}>
                      <span>53,351</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>کارتن</td>
                    <td>سایز 1 (10*10*15)</td>
                    <td className={styles.priceTD}>
                      <span>40,150</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>کارتن</td>
                    <td>سایز 2 (10*15*20)</td>
                    <td className={styles.priceTD}>
                      <span>58,301</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>کارتن</td>
                    <td>سایز 3 (15*20*20)</td>
                    <td className={styles.priceTD}>
                      <span>94,601</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>کارتن</td>
                    <td>سایز 4 (20*20*30)</td>
                    <td className={styles.priceTD}>
                      <span>167,200</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>کارتن</td>
                    <td>سایز 5 (20*25*35)</td>
                    <td className={styles.priceTD}>
                      <span>233,751</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>کارتن</td>
                    <td>سایز 6 (20*25*45)</td>
                    <td className={styles.priceTD}>
                      <span>294,250</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>کارتن</td>
                    <td>سایز 7 (25*30*40)</td>
                    <td className={styles.priceTD}>
                      <span>385,001</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>کارتن</td>
                    <td>سایز 8 (30*40*45)</td>
                    <td className={styles.priceTD}>
                      <span>675,400</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>کارتن</td>
                    <td>سایز 9 (35*45*55)</td>
                    <td className={styles.priceTD}>
                      <span>1,070,163</span>
                      <span>ریال</span>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>

        {pageImage}
      </main>

      <Footer />
    </Fragment>
  );
};

export default ContentBox;
